export default {"src":"/_next/static/media/waffles.b7faebfe.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};